var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.noticeShow)?_c('div',{staticClass:"success-main"},[_vm._m(0)]):_vm._e(),_c('div')])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-box"},[_c('div',{staticClass:"img-box animated zoomIn"},[_c('img',{staticClass:"ok-img",attrs:{"src":"https://img.nanshikeji.cn/img/wechat/reg-success.png"}}),_c('div',{staticClass:"ok-text"},[_vm._v("做的太棒了！老师给你点赞!")])])])
}]

export { render, staticRenderFns }